











import { BlockLabel } from "@/models/BlockLabel";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "DelayedInvoice",
  props: {
    blockId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      displayName: BlockLabel.DelayedInvoice,
    };
  },
  mounted() {
    this.$emit("updateBlock", {
      blockId: this.blockId,
      type: this.$options.name,
    });
  },
});
